import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { all, call, Effect, put, putResolve, select } from 'redux-saga/effects';
import Select, { ValueType } from 'react-select';
import { Button, Form, Input, Alert } from 'reactstrap';
import { Dispatch } from 'redux';
import urlencode from 'urlencode';
import { Privilege, GroupCollection ,User } from '../../clients/aasServerClient.generated';
import { applicationOptions } from '../../stores/applications/selectors';
import { getAssignablePrivileges, hideGroups } from '../../stores/auth/selectors';
import { groupOptionsPerWorkspace } from '../../stores/groups/selectors';
import { isLoading } from '../../stores/navigation/selectors';
import { RootState } from '../../stores/store';
import { clearSingleUser, copySingleUser, createSingleUser, fetchSingleUser, newSingleUser, saveSingleUser } from '../../stores/users/actionCreators';
import { getSingleUser } from '../../stores/users/selectors';
import ApplicationsSelect from '../applications/ApplicationSelect';
import FormInput from '../common/FormInput';
import SideModal from '../common/modals/SideModal';
import GroupsSelect from '../groups/GroupSelect';
import { LoadingButton } from '../navigation/LoadingButton';
import LoadingScreen from '../navigation/LoadingScreen';
import WorkspaceSelect from '../workspaces/WorkspaceSelect';
import PrivilegeSelector from './PrivilegeSelector';
import UserProperties from './UserProperties';
import {fetchGroupsPerWorkspace} from '../../stores/groups/actionCreators';
import * as GroupRepository from '../../repositories/GroupRepository';
import { TableFilters,TablePaging, TableSorting } from '../../stores/tables/state';
import { getFilter, getFilters, getLimit, getPaging, getSearch, getSorting, getStart } from '../../stores/tables/selectors';



interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string | undefined }> {
    isLoading: boolean;
    user: {
        loaded: boolean;
        saved: boolean;
        user?: Partial<User>;
    };

    applications: Array<{ label: string, value: string }>;
    groups: Array<{ label: string, value: string }>;
    copySingleUser: (id: string) => void;
    newSingleUser: () => void;
    clearSingleUser: () => void;
    createSingleUser: (
        mail: boolean | undefined,
        user: Partial<User>,
        workspaceId?: string,
        apps?: Array<{ id: string, value: boolean }>,
        groups?: Array<{ id: string, value: boolean }>,
        privileges?: Array<{ name: string, value: boolean }>
    ) => void;
    assignable: Privilege[];
    fetchGroupsPerWorkspace: (workspaceId: string[])=>void;
    hideGroups?: boolean;
}

interface State {
    user?: Partial<User>;
    privilegeSelection?: Array<{ id: string, value: boolean }>;
    applicationSelection?: ValueType<{ label: string, value: string }>;
    groupSelection?: ValueType<{ label: string, value: string }>;
    newGroups?:  Array<{ label: string, value: string }>;
    workspaceSelection?: { label: string, value: string };
    showAlert: boolean;
    isCopy: boolean;
}

class NewUserPage extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        const id = this.props.match.params.id;
        if (id) {
            this.state = {
                isCopy: true,
                privilegeSelection: undefined,
                user: undefined,
                showAlert: false,
                
            };
            this.props.clearSingleUser();
            this.props.copySingleUser(id);
        } else {
            this.state = {
                isCopy: false,
                privilegeSelection: undefined,
                user: undefined,
                showAlert: false
            };
            this.props.clearSingleUser();
            this.props.newSingleUser();
        }
    }

    public modalRef = React.createRef<HTMLDivElement>();

    public componentDidUpdate(prevProps: Props) {
        if (!prevProps.user.loaded && this.props.user.loaded) {
            this.setState({
                user: this.props.user.user,
            });
        }
        if (!prevProps.user.saved && this.props.user.saved) {
            this.closePage();
        }
    }

    public render() {
        const t = this.props.translate;
        return (
            <SideModal
                isOpen={true}
                toggle={this.closePage}
                headerText={this.state.isCopy ? t('users.edit.header.copy') as string
                    : t('users.edit.header.add') as string}
                footer={this.renderFooter()}
                objectRef={this.modalRef}
            >
                {this.props.user.loaded && this.props.user.user ? (
                    <Form>
                        {this.state.showAlert ? <Alert color="danger">{t('users.edit.error.fields_empty')}</Alert> : null}
                        <h3 className="mb-4 mt-2">{t('users.edit.section.details')}</h3>
                        <UserProperties type="new" user={this.props.user.user} updateUser={this.updateUser} />
                        {this.props.user.user!.workspace ? (
                            <React.Fragment>
                                <hr className="fill-modal" />
                                <h3 className="mb-4 mt-4">{t('users.edit.section.workspace') + '*'}</h3>
                                <WorkspaceSelect
                                    selected={this.props.user.user.workspace.id}
                                    updateSelection={this.updateWorkspaceSelection}
                                    selection={this.state.workspaceSelection}
                                />
                            </React.Fragment>
                        ) : null}
                        {this.props.user.user!.applications ? (
                            <React.Fragment>
                                <hr className="fill-modal" />
                                <h3 className="mb-4 mt-4">{t('users.edit.section.applications')}</h3>
                                <ApplicationsSelect
                                    selected={this.props.user.user.applications.map((app) => app.id)}
                                    updateSelection={this.updateApplicationSelection}
                                    selection={this.state.applicationSelection}
                                />
                            </React.Fragment>
                        ) : null}
                        {this.props.hideGroups === false && this.props.user.user!.groups ? (
                            <React.Fragment>
                                <hr className="fill-modal" />
                                <h3 className="mb-4 mt-4">{t('users.edit.section.groups')}</h3>
                                <GroupsSelect
                                    selected={this.props.user.user.groups.map((group) => group.id)}
                                    updateSelection={this.updateGroupSelection}                                    
                                    selection={this.state.groupSelection}
                                    filterPerWorkspace= {true}
                                />
                            </React.Fragment>
                        ) : null}
                        {this.props.user.user!.privileges ? (
                            <React.Fragment>
                                <hr className="fill-modal" />
                                <h3 className="mb-4 mt-4">{t('users.edit.section.privileges')}</h3>
                                <PrivilegeSelector
                                    privileges={this.props.user.user!.privileges}
                                    updateSelection={this.updatePrivilegeSelection}
                                />
                            </React.Fragment>
                        ) : null}

                    </Form>
                ) : (
                        <LoadingScreen text={t('loading.loading') as string} />
                    )}
            </SideModal>
        );
    }

    private updateUser = (user: Partial<User>) => {
        this.setState({
            user,
        });
    }

    private updatePrivilegeSelection = (selection: Array<{ id: string, value: boolean }>) => {
        this.setState({ privilegeSelection: selection });
    }

    private updateApplicationSelection = (selection: ValueType<{ label: string, value: string }>) => {
        this.setState({ applicationSelection: selection });
    }

    private updateGroupSelection = (selection: ValueType<{ label: string, value: string }>) => {
        this.setState({ groupSelection: selection });
    }

    

    private updateWorkspaceSelection = (selection: ValueType<{ label: string, value: string }> |
    { label: string, value: string }) => {
        this.setState({ workspaceSelection: selection as { label: string, value: string } }, ()=>{
            this.props.fetchGroupsPerWorkspace([this.state.workspaceSelection?.value??""]);
        });
   }
   

    private closePage = () => {
        this.props.history.push('/users');
    }

    private renderFooter = (): React.ReactNode => {
        const t = this.props.translate;
        return (
          <React.Fragment>
              <LoadingButton
                loading={this.props.isLoading}
                color='success'
                onClick={() => this.createUser(true)}
                style={{ width: '200px' }}
                >
                    {t('users.edit.button.saveAndMail')}
              </LoadingButton>
              <LoadingButton
                loading={this.props.isLoading}
                color='success'
                onClick={() => this.createUser()}
                style={{ width: '200px' }}
                >
                    {t('users.edit.button.save')}
              </LoadingButton>
            </React.Fragment>
        );
    }

    private createUser = (mail?: boolean) => {
        let setAlert =
          (this.state.user?.email || '') === '' ||
          (this.state.user?.first_name || '') === '' ||
          (this.state.user?.last_name || '') === '' ||
            this.state.workspaceSelection === undefined;
        if (setAlert) {
            this.setState({ showAlert: true }, () => {
                if (this.modalRef && this.modalRef.current && this.modalRef.current.parentElement) {
                  this.modalRef.current.parentElement.scrollTop = 0;
                }
            });
            return;
        }
        const user = this.state.user;
        let apps: Array<{ id: string; value: boolean }> | undefined;
        let appsSelect = new Array();
        if (this.state.applicationSelection) {
            appsSelect.push(this.state.applicationSelection);
            apps = this.props.applications.map((app) => ({
                id: app.value,
                // tslint:disable-next-line:no-any
                value: (appsSelect as any[])
                    .find((x) => x.value === app.value) !== undefined,
            }));
        }
        let groups: Array<{ id: string; value: boolean }> | undefined;
        if (this.state.groupSelection) {
            groups = this.props.groups.map((group) => ({
                id: group.value,
                // tslint:disable-next-line:no-any
                value: (this.state.groupSelection as any[]).find((x) => x.value === group.value) !== undefined,
            }));
        }
        let privileges: Array<{ name: string; value: boolean }> | undefined;
        if (this.state.privilegeSelection) {
            privileges = this.state.privilegeSelection.map((p) => ({
                name: p.id,
                value: p.value
            }));
        }
        const workspaceId = this.state.workspaceSelection?.value;
        this.props.createSingleUser(mail, user!, workspaceId, apps, groups, privileges);
    }
}

const mapStateToProps = (state: RootState) => ({
    applications: applicationOptions(state),
    groups: groupOptionsPerWorkspace(state),
    hideGroups: hideGroups(state),
    isLoading: isLoading(state),
    user: getSingleUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    clearSingleUser: () => dispatch(clearSingleUser()),
    copySingleUser: (id: string) => dispatch(copySingleUser(id)),
    createSingleUser: (
        mail: boolean | undefined,
        user: Partial<User>,
        workspaceId?: string,
        apps?: Array<{ id: string, value: boolean }>,
        groups?: Array<{ id: string, value: boolean }>,
        privileges?: Array<{ name: string, value: boolean }>
    ) => dispatch(createSingleUser(mail, user, workspaceId, apps, groups, privileges)),
    newSingleUser: () => dispatch(newSingleUser()),
    fetchGroupsPerWorkspace: (workspaceIds: string[])=> dispatch(fetchGroupsPerWorkspace(workspaceIds))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(NewUserPage)));